module.exports = __webpack_public_path__ + "static/media/preq.a22b7d94.png";